import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=37d974af&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d974af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d974af')) {
      api.createRecord('37d974af', component.options)
    } else {
      api.reload('37d974af', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=37d974af&scoped=true&", function () {
      api.rerender('37d974af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NQWjf4JIv8Ty/JS/comp/Accordion.vue"
export default component.exports